import styled from 'styled-components'
import { colors } from '../../constants'

interface HeadingProps {
    bold?: boolean
    capitalized?: boolean
    color?: string
    inline?: boolean
    italic?: boolean
}

const Heading = styled.span<HeadingProps>`
    ${({ bold }) => bold && 'font-weight: bold;'}
    ${({ capitalized }) => capitalized && 'text-transform: uppercase;'}
  ${({ color }) => color && `color: ${color}`}
  ${({ inline }) => inline && 'display: inline-block;'}
  ${({ italic }) => italic && 'font-style: italic;'}
`

const H1 = styled(Heading)`
    font-size: 35px;
`

const H2 = styled(Heading)`
    font-size: 20px;
`

const H3 = styled(Heading)`
    font-size: 16px;
`

const H4 = styled(Heading)`
  color: ${colors.grey}
  font-size: 16px;
`

const H5 = styled(Heading)`
  color: ${colors.grey}
  font-size: 13.3px;
`

export default { H1, H2, H3, H4, H5 }
